<template>
  <transition name="fade-loading">
    <div class="loading" v-show="isShow">
      <i-spin size="large" fix></i-spin>
    </div>
  </transition>
</template>

<script>
import { Spin } from 'view-design'
export default {
  components: {
    'i-spin': Spin,
  },
  data() {
    return {}
  },
  computed: {
    isShow() {
      return this.$store.getters['Loading/getLoading']
    },
  },
}
</script>

<style lang="scss">
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-spin-fix {
    background-color: rgba(255, 255, 255, 0.8);
  }
}
.fade-loading {
  &-enter-active,
  &-leave-active {
    transition: opacity 0.5s;
  }
  &-enter,
  &-leave-to {
    opacity: 0;
  }
}
</style>
